import { useMemo } from 'react';
import {
  catalogueWidgetSwitchedOff,
  widgetSwitchedOff,
  type DashboardCatalogueId,
  type DashboardWidgetKey,
} from '@efacture/core/sector';

import { useNavPreferences } from '@/api/queries/ui-preferences';

export interface CompanyDisabledWidgets {
  /** True when a module the company switched off closes this `/dashboard` widget's data. */
  widget: (key: DashboardWidgetKey) => boolean;
  /** True when a module the company switched off closes the widgets of dashboard `id`. */
  catalogueWidget: (id: DashboardCatalogueId) => boolean;
}

/**
 * The dashboards' company layer: the switched-off modules the menu resolves
 * (`nav.disabled`, kept per tenant offline), applied to the widgets through
 * the same core functions the summary endpoint uses. Until a value was ever
 * loaded for the tenant, no widget is removed.
 */
export function useCompanyDisabledWidgets(): CompanyDisabledWidgets {
  const { companyDisabled } = useNavPreferences();
  return useMemo(() => {
    const disabled = new Set(companyDisabled ?? []);
    return {
      widget: (key) => widgetSwitchedOff(key, disabled),
      catalogueWidget: (id) => catalogueWidgetSwitchedOff(id, disabled),
    };
  }, [companyDisabled]);
}
